import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  bgColor?: string;
  fontColor?: string;
}

export const Tag = styled.span<IProps>`
  ${mixin.flex({ display: 'inline-flex' })}

  svg + span {
    margin-left: 4px;
  }

  font-size: 11px;
  padding: 3px 6px;
  line-height: 110%;
  font-weight: 500;

  &.tag-soldout {
    color: #fff;
    background-color: #bbbbbb;
  }

  ${props => {
    const { bgColor, fontColor } = props;

    return css`
      color: ${fontColor || '#777'};
      background-color: ${bgColor || '#f6f6f6'};
    `;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    svg + span {
      margin-left: ${mixin.pxToVw('4')};
    }

    font-size: ${mixin.pxToVw('11')};
    padding: ${mixin.pxToVw('3 6')};
  }

  @media ${({ theme }) => theme.media.pc} {
    font-size: 12px;
  }
`;
